import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { ActiveFacetsModule, FacetModule, IconModule, KeyboardFocusModule, ProductFacetNavigationComponent } from '@spartacus/storefront';
import { CustomProductFacetListComponent } from '../custom-product-facet-list/custom-product-facet-list.component';

@Component({
  selector: 'cx-product-facet-navigation',
  standalone: true,
  imports: [CommonModule, FacetModule, I18nModule, IconModule, KeyboardFocusModule, CustomProductFacetListComponent, ActiveFacetsModule],
  templateUrl: './custom-product-facet-navigation.component.html',
  styleUrl: './custom-product-facet-navigation.component.scss'
})
export class CustomProductFacetNavigationComponent extends ProductFacetNavigationComponent{

}
